
import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './gambling.json';

const Gambling = () => {
  return (
    <div className="topic-page-container">
        <TopicsPageLayout
            
            description="Gambling vocabulary, addiction, and regulation discussions. B2/C1 level grammar, reading, and discussion exercises."
            level="B2"
            title="Gambling"
            image="/Images/gambling.webp"
            seoTitle="Free English Lesson Plans: Gambling"
            seoDescription="Gambling vocabulary, addiction, and regulation discussions. B2/C1 level grammar, reading, and discussion exercises."
        >
            {topicData.map((section, index) => (
                <div key={index} className="lesson-section-wrapper">
                    <TopicsRouter sectionData={section} />
                </div>
            ))}
        </TopicsPageLayout>
    </div>
  );
};

export default Gambling;


